export class AppConstants{
    static readonly SESSION_VAR_USER= 'user';
    static readonly SESSION_VAR_TOKEN='auth_token';

    static readonly SESSION_VAR_TAGS='tags';
    static readonly SESSION_VAR_SEGMENTS='tags';
};
export const  SESSION_VAR_STATE='page_state';
